import { Paths } from '../../lib/constants/path'
import { RoleEnum } from '../../lib/types/enums/users/role.enum'
import { Route } from '../../lib/types/routes'
import TripsMonitoringListPage from './trips-monitoring-list'

const tripsMonitoringRoutes: Route[] = [
  {
    path: Paths.TRIPS_MONITORING,
    element: <TripsMonitoringListPage />,
    roles: [RoleEnum.ADMIN]
  }
]

export default tripsMonitoringRoutes
